/**
 * BrandAuditDetailPresenter
 * --
 */
import React from 'react';

const BrandAuditDetailPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p>BrandAuditDetailPresenter</p>
    </div>
  );
};

export default BrandAuditDetailPresenter;
